import * as React from 'react';

import { cn } from '@/lib/utils';

const PSInput = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "tw-w-full tw-px-3 tw-py-2 tw-rounded-md tw-border tw-border-gray-300 tw-bg-white placeholder:tw-text-gray-400 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-border-blue-500 disabled:tw-bg-gray-50 disabled:tw-text-gray-500",
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
PSInput.displayName = 'Input';

export { PSInput };
